

export const profile = {
  name: "Gokulakrishnan A",
  title: "Full Stack Developer ",
  bio: "Building responsive, modern web applications with a focus on user experience. Proficient in React, Node.js, and a lover of clean code.",
 
  imagePath: "/profile.jpg",
  ctaText: "View my work",
  socials: {
    github: "https://github.com/Gokulproject5",
    linkedin: "https://linkedin.com/in/gokulakrishnana-a8608",
    instagram: "https://instagram.com/your-handle"
  }
};
